const state = {
  cache: {},
  waterQuality: {}
}

const mutations = {
  SET_CACHE(state, cache) {
    state.cache = cache
  },
  SET_WATER_QUALITY(state, {waterQuality}) {
    state.waterQuality = {...waterQuality}
  },
  setCache(state, { cache }) {
    // const [id, detail] = Object.entries(cache)[0]
    // state.cache = { ...state.cache, [id]: detail }
    state.cache = { ...cache }
  }
}

const actions = {
  cacheDetail({ commit }, detail) {
    commit('SET_DETAIL', detail)
  },
  cacheWaterQuality({ commit }, waterQuality) {
    commit('SET_WATER_QUALITY', waterQuality)
  }
}

const getters = {
  detail: state => state.detail,
  waterQuality: state => state.waterQuality
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
